import React from "react"
import * as api from "brandguard/api"
import GenerateCorrectionShared from "brandguard/components/generate.correction"

interface props {
	item: api.TextSearchResponseItem
	onCorrectionComplete?: (correctedEventId: string) => void
}

export default function GenerateCorrection(props: props): JSX.Element {
	return <GenerateCorrectionShared item={props.item} corrections={api.text.corrections} progressLabel="text" onCorrectionComplete={props.onCorrectionComplete} />
}
